var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkBullet = function SvgCheckmarkBullet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.666 16-3.253-3.72.453-4.92-4.813-1.093L20.533 2 16 3.947 11.466 2l-2.52 4.253-4.813 1.08.453 4.934L1.333 16l3.253 3.72-.453 4.933 4.813 1.094L11.466 30 16 28.04l4.533 1.947 2.52-4.254 4.813-1.093-.453-4.92L30.666 16Zm-17.213 6.293-5.067-5.08 1.974-1.973 3.093 3.107 7.8-7.827 1.973 1.973-9.773 9.8Z",
    fill: "currentColor"
  })));
};
export default SvgCheckmarkBullet;